export default "__VITE_PUBLIC_ASSET__722d58e5__"